export async function writeDesktopLog(
  level: DesktopLogEntry['level'],
  message: string,
  context?: unknown,
) {
  console[level === 'error' ? 'error' : level === 'warn' ? 'warn' : 'log'](message, context ?? '');

  if (!window.desktop) {
    return;
  }

  await window.desktop.log.write({ level, message, context });
}

